import { useEffect, useState } from 'react';

type UseDropdownPositionOptions = {
  isOpen: boolean;
  anchorRef: React.RefObject<HTMLElement | null>;
  offset?: number;
};

type Position = {
  top: number;
  right: number;
};

export function useDropdownPosition({ isOpen, anchorRef, offset = 8 }: UseDropdownPositionOptions): Position {
  const [position, setPosition] = useState<Position>({ top: 0, right: 0 });

  useEffect(() => {
    if (!isOpen || !anchorRef.current) return;

    const updatePosition = () => {
      if (anchorRef.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom + offset,
          right: window.innerWidth - rect.right,
        });
      }
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [isOpen, anchorRef, offset]);

  return position;
}
